module.exports = __webpack_public_path__ + "static/media/undraw_cloudflare-dev_nf79.33554823.svg";